import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const IconArrowTopRight = props => (
  <SvgIcon {...props} viewBox="0 0 10 10">
    <path d="m1.5899 10 6.0523-6.0088v4.2019h2.3578v-8.1931h-8.2524v2.3409h4.2323l-5.9799 5.937 1.5899 1.7221z" />
  </SvgIcon>
);

export default IconArrowTopRight;



// WEBPACK FOOTER //
// ./src/components/icons/IconArrowTopRight.js